import React, { useState } from 'react';

import {
  attachInviteAttributionToUrl,
  canUseInviteFeature,
  getMyInviteLink,
} from '../../api/inviteApi';
import { useToast } from '../Toast';
import { useAuth } from '../../contexts/AuthContext';
import { trackInviteShare } from '../../utils/eventTracker';
import { shareContent, shareToKakao } from '../../utils/shareUtils';
import './TeacherReferralShareButton.css';


const TeacherReferralShareButton = ({
  className = '',
  label = '동료에게 알려주기',
  surface = 'feature-result',
}) => {
  const { currentUser } = useAuth();
  const { showToast } = useToast();
  const [sharing, setSharing] = useState(false);

  if (!currentUser || !canUseInviteFeature(currentUser)) return null;

  const handleShare = async () => {
    if (sharing) return;
    setSharing(true);
    try {
      const invite = await getMyInviteLink(currentUser);
      const shareUrl = attachInviteAttributionToUrl(
        invite.share_url,
        invite.share_url,
        surface,
      );
      const shareData = {
        title: '선생님께 왓퀴즈를 추천해요',
        text: '교사 업무를 빠르게 끝내는 AI 도구를 확인해보세요.',
        url: shareUrl,
      };
      let result = await shareToKakao(shareData);
      if (!result.success) result = await shareContent(shareData);

      if (result.success) {
        trackInviteShare(surface, result.method, true);
        showToast(
          result.method === 'clipboard'
            ? '초대 링크를 복사했어요'
            : '공유 화면을 열었어요',
          'success',
        );
      } else if (!result.error?.includes('취소')) {
        showToast('공유하지 못했어요. 다시 시도해주세요.', 'error');
      }
    } catch (_error) {
      showToast('초대 링크를 준비하지 못했어요. 다시 시도해주세요.', 'error');
    } finally {
      setSharing(false);
    }
  };

  return (
    <button
      aria-label={label}
      className={`teacher-referral-share ${className}`.trim()}
      data-share-surface={surface}
      disabled={sharing}
      onClick={handleShare}
      type="button"
    >
      {sharing ? '공유 준비 중' : label}
    </button>
  );
};

export default TeacherReferralShareButton;
